<template>
  <div>
    <div id="updateSettings">
      <div class="tabs-head">
        <router-link :to="linkToAnalytics()">
          <div class="tabs-head__item">
            <p>Analytics</p>
          </div>
        </router-link>
        <router-link :to="linkToSettings()">
          <div class="tabs-head__item activeTab">
            <p>Settings</p>
          </div>
        </router-link>
      </div>
      <div class="settings">
        <CreateUpdateGate v-if="isTapmixer()" :is-update="true"/>
        <CreateUpdateCampaign v-if="isFanfrick()" :is-update="true"/>
      </div>
    </div>
  </div>
</template>
<script>
import CreateUpdateGate from "@/views/CreateUpdateGate/CreateUpdateGate";

import CreateUpdateCampaign from "../CreateUpdateCampaign/CreateUpdateCampaign";

export default {
  name: 'SharedSettings',
  components: {
    CreateUpdateCampaign,
    CreateUpdateGate,
  },
  data() {
    return {
      currentId: this.$route.params.id,
      currentSocial: this.$route.params.social
    }
  },
  methods: {
    linkToAnalytics() {
      return this.isTapmixer() ?
          '/my-gates/' + this.currentId + '/analytics' :
          '/my-gates/' + this.currentId + '/' + this.currentSocial + '/analytics'
    },
    linkToSettings() {
      return this.isTapmixer() ?
          '/my-gates/' + this.currentId + '/settings' :
          '/my-gates/' + this.currentId + '/' + this.currentSocial + '/settings'
    }
  }
}

</script>
<style lang="sass">
#updateSettings
  .tabs-head
    border-bottom: 1px solid #BDBDBD
    display: flex
    flex-direction: row
    justify-content: flex-start
    padding: 30px 0 0 0
    a
      .tabs-head__item
        width: 100px
        height: 40px
        display: flex
        align-items: center
        justify-content: center
        margin: 0 10px -1px 0
        border: 1px solid #BDBDBD
        border-radius: 5px 5px 0 0
        cursor: pointer
        p
          color: #777777
          font-weight: 400
      .activeTab
        border-bottom: 1px solid #fff
        p
          color: #454545
</style>
